export default __webpack_public_path__ + "images/UJ.f1008f5.png";